import type { Nil } from "cy-util";

type ParseFetchOptions = RequestInit & {
  next?: unknown;
};

/*
 * modified the default fetch options to disable caching instead of enabling it.
 * Also sets the default method to GET explicitly instead of it being implicit
 * */
export function parseFetchOptions(
  options?: ParseFetchOptions | Nil,
  { isFormData }: { isFormData?: boolean } = {},
) {
  options = options || {};
  options.method = options.method || "GET";
  // Change default to not cache
  if (!options.cache && !options.next) {
    options.cache = "no-store";
  }
  const keys: string[] =
    typeof options.headers?.keys === "function"
      ? Array.from(options.headers.keys() as any)
      : Object.keys(options?.headers || {});
  const lcKeys = keys.map((x) => x.toLowerCase());

  const hasContentType = lcKeys.some((x) => x === "content-type");
  const headers: any = options.headers || ({} as any);
  if (!hasContentType && !isFormData) {
    headers["content-type"] = "application/json";
  }
  options.headers = headers;
  return options;
}
